export default __webpack_public_path__ + "static/media/journeytray-greentree-fruitflower.43fa63ff.svg";